import { render, staticRenderFns } from "./AnnouncementDetail.vue?vue&type=template&id=bc036800&scoped=true"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDetail.vue?vue&type=style&index=0&id=bc036800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc036800",
  null
  
)

export default component.exports